// Names the map editor's things get on their own, per language: data, not UI text (tools/i18n-allow.txt). The Chinese
// one is what is stored and what the office and agents see (`deck seats`, `deck sit 会议圆桌`); the page shows the
// reader's (deck/places.js). A name someone typed stays as typed (docs/i18n.md "Place names").
/** A room nobody named (map-overlay.js normalizeOverlay). */
export const ROOM_DEFAULT_NAMES = {
  meeting: { 'zh-CN': '会议室', en: 'Meeting room' },
  quiet: { 'zh-CN': '安静区', en: 'Quiet room' },
};
/** The seats on a piece of furniture placed in the editor (map-overlay.js applyOverlay), by prop id. */
export const PROP_SEAT_NAMES = {
  workdesk: { 'zh-CN': '电脑桌椅', en: 'Desk' },
  desk: { 'zh-CN': '电脑桌椅', en: 'Desk' },
  meeting: { 'zh-CN': '会议圆桌', en: 'Round table' },
  bench: { 'zh-CN': '长凳', en: 'Bench' },
  cushion: { 'zh-CN': '坐垫', en: 'Cushion' },
};
